import DeleteIcon from '@mui/icons-material/Delete';
import {
    Autocomplete,
    Button,
    FormControl,
    FormGroup,
    FormHelperText,
    FormLabel,
    Grid,
    TextField,
} from '@mui/material';

import useStylesForm from 'common/components/styles/useStylesForm.styles';
import YesNoDialog from 'common/components/YesNoDialog';
import LabelsInput from 'common/features/labels/LabelsInput';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ValidatorForm } from 'react-material-ui-form-validator';
import useStylesProductForm from '../styles/useStylesProductForm.styles';

const ProductFormOptions = (props) => {
    const { options, productsOptions, setOptions, variants, setVariants, readOnly } = props;

    const { t } = useTranslation();

    const { classes: classes1 } = useStylesForm();
    const { classes: classes2, cx } = useStylesProductForm();
    const classes = { ...classes1, ...classes2 };

    const [openConfirmDeleteDlg, setOpenConfirmDeleteDlg] = useState(false);

    const [deleteIdx, setDeleteIdx] = useState(-1);

    const deleteConfirmTitle = t('product.productFormOptions.deleteConfirm');
    const deleteConfirmMessage = t('product.productFormOptions.deleteMessage');

    const addOption = (e) => {
        e.preventDefault();
        setOptions([
            ...options,
            {
                name: '',
                values: [],
            },
        ]);
    };

    const handleTagChange = (tags, idx) => {
        variantChangeOptions(idx, tags, 'tags');
        let newOpt = [...options];
        let opt = {
            name: options[idx].name,
            values: tags,
        };
        newOpt[idx] = opt;
        setOptions(newOpt);
    };

    const handleDelete = (e, idx) => {
        e.preventDefault();
        setDeleteIdx(idx);
        setOpenConfirmDeleteDlg(true);
    };

    const confirmDelete = () => {
        deleteOption(deleteIdx);
        setOpenConfirmDeleteDlg(false);
    };

    const cancelDlg = () => {
        setOpenConfirmDeleteDlg(false);
    };

    const deleteOption = (idx) => {
        variantChangeOptions(idx, '', 'delete');
        let newOpt = [...options];
        newOpt = newOpt.filter((op, index) => index !== idx);
        setOptions(newOpt);
    };

    const handleFieldChange = (e, idx) => {
        variantChangeOptions(idx, e, 'edit');
        let newOpt = [...options];
        let opt = {
            name: e,
            values: options[idx].values,
        };

        newOpt[idx] = opt;
        setOptions(newOpt);
    };

    const variantChangeOptions = (idx, data, type) => {
        let newVariants = [];
        variants.forEach((v) => {
            let variant = {
                ...v,
                selectedOptions: v.selectedOptions,
            };
            let j = v.selectedOptions.findIndex((o) => o.name === options[idx].name);
            if (j !== -1) {
                if (type === 'edit') {
                    let newOpt = v.selectedOptions;
                    newOpt = newOpt.filter((op, index) => index !== j);
                    let opt = {
                        name: data,
                        value: v.selectedOptions[j].value,
                    };
                    newOpt = [...newOpt, opt];
                    variant.selectedOptions = newOpt;
                }
                if (type === 'delete') {
                    variant.selectedOptions = [];
                }
                if (type === 'tags') {
                    let index = data.findIndex((d) => d === v.selectedOptions[j].value);
                    if (index === -1) {
                        variant.selectedOptions = [];
                    }
                }
            }
            if (variant.selectedOptions.length > 0) {
                newVariants = [...newVariants, variant];
            }
        });
        setVariants(newVariants);
    };

    const validateOptionsName = (idx, name) => {
        let index = options.findIndex((o, i) => i !== idx && o.name === name);
        return index !== -1;
    };

    const submit = () => {
        console.debug('submit');
    };

    return (
        <React.Fragment>
            <div>
                {options.length > 0 && <FormLabel>{t('product.productFormOptions.options')}</FormLabel>}
                {options.map((option, idx) => (
                    <ValidatorForm
                        onSubmit={submit}
                        onError={() => {}}
                        key={idx}
                        className={cx(classes.form, classes.settingsForm)}
                    >
                        <Grid container spacing={1} className={classes.optionsRow}>
                            <Grid item md={4}>
                                <FormGroup>
                                    <FormControl className={classes.formControl}>
                                        <Autocomplete
                                            freeSolo
                                            disableClearable={true}
                                            options={productsOptions}
                                            onChange={(event, newValue) => {
                                                handleFieldChange(newValue ? newValue : '', idx);
                                            }}
                                            inputValue={option.name}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    className={classes.textField}
                                                    InputProps={{
                                                        readOnly: readOnly,
                                                    }}
                                                    autoComplete="new-opt"
                                                    name="name"
                                                    error={validateOptionsName(idx, option.name)}
                                                    type="text"
                                                    onChange={(e) => handleFieldChange(e.target.value, idx)}
                                                    variant="outlined"
                                                    size="small"
                                                    placeholder={t('product.productFormOptions.optionsPlaceholder')}
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </FormGroup>
                            </Grid>
                            <Grid item md={readOnly ? 8 : 7}>
                                <FormGroup>
                                    <FormControl className={classes.formControl}>
                                        <LabelsInput
                                            deleteAction={true}
                                            // namespace={'product'}
                                            readOnly={readOnly}
                                            labels={option.values}
                                            onChange={(e) => handleTagChange(e, idx)}
                                            placeholder={t('product.productFormOptions.tagsPlaceholder')}
                                            size={'medium'}
                                        />
                                    </FormControl>
                                </FormGroup>
                            </Grid>
                            {!readOnly && (
                                <Grid item md={1}>
                                    <DeleteIcon
                                        disabled={readOnly}
                                        className={classes.formControl}
                                        onClick={(e) => handleDelete(e, idx)}
                                    />
                                </Grid>
                            )}
                        </Grid>
                        {validateOptionsName(idx, option.name) && (
                            <FormHelperText error className={classes.mtNeg10px}>
                                {t('product.productFormOptions.optionNoRepeat')}
                            </FormHelperText>
                        )}
                    </ValidatorForm>
                ))}

                {!readOnly && (
                    <Button
                        disabled={readOnly}
                        className={cx(classes.buttonStyle, classes.addOption)}
                        variant="contained"
                        size="small"
                        disableElevation={true}
                        onClick={addOption}
                    >
                        {t('product.productFormOptions.add')}
                    </Button>
                )}
            </div>

            <YesNoDialog
                openDialog={openConfirmDeleteDlg}
                title={deleteConfirmTitle}
                messageToConfirm={deleteConfirmMessage}
                yesButtonCallback={() => {
                    confirmDelete();
                }}
                noButtonCallback={() => {
                    cancelDlg();
                }}
            />
        </React.Fragment>
    );
};

export default ProductFormOptions;
